// Screen width breakpoints
export const SCREEN_BREAKPOINTS = {
    DESKTOP: 1024, // Width in pixels for desktop
    TABLET: 768,   // Width in pixels for tablet
    MOBILE: 480,   // Width in pixels for mobile
};